// Current subscription status
export const FETCH_CURRENT_SUBSCRIPTION = "FETCH_CURRENT_SUBSCRIPTION"
export const FETCH_CURRENT_SUBSCRIPTION_SUCCESS = "FETCH_CURRENT_SUBSCRIPTION_SUCCESS"
// Abonelik durumu en az bir kez sorgulandı (başarılı VEYA hatalı) — gate bunu bekler
export const SET_SUBSCRIPTION_RESOLVED = "SET_SUBSCRIPTION_RESOLVED"

// Available plans
export const FETCH_PLANS = "FETCH_PLANS"
export const FETCH_PLANS_SUCCESS = "FETCH_PLANS_SUCCESS"

// Invoice info
export const FETCH_INVOICE_INFO = "FETCH_INVOICE_INFO"
export const FETCH_INVOICE_INFO_SUCCESS = "FETCH_INVOICE_INFO_SUCCESS"

// Price calculation
export const CALCULATE_PRICE = "CALCULATE_PRICE"
export const CALCULATE_PRICE_SUCCESS = "CALCULATE_PRICE_SUCCESS"

// Coupon validation
export const VALIDATE_COUPON = "VALIDATE_COUPON"
export const VALIDATE_COUPON_SUCCESS = "VALIDATE_COUPON_SUCCESS"
export const CLEAR_COUPON = "CLEAR_COUPON"

// Purchase
export const PURCHASE_SUBSCRIPTION = "PURCHASE_SUBSCRIPTION"
export const PURCHASE_SUBSCRIPTION_SUCCESS = "PURCHASE_SUBSCRIPTION_SUCCESS"

// History
export const FETCH_SUBSCRIPTION_HISTORY = "FETCH_SUBSCRIPTION_HISTORY"
export const FETCH_SUBSCRIPTION_HISTORY_SUCCESS = "FETCH_SUBSCRIPTION_HISTORY_SUCCESS"

// 402 Payment Required
export const SET_PAYMENT_REQUIRED = "SET_PAYMENT_REQUIRED"
export const CLEAR_PAYMENT_REQUIRED = "CLEAR_PAYMENT_REQUIRED"

// Downgrade
export const SCHEDULE_DOWNGRADE = "SCHEDULE_DOWNGRADE"
export const SCHEDULE_DOWNGRADE_SUCCESS = "SCHEDULE_DOWNGRADE_SUCCESS"

// Cancel
export const CANCEL_SUBSCRIPTION = "CANCEL_SUBSCRIPTION"
export const CANCEL_SUBSCRIPTION_SUCCESS = "CANCEL_SUBSCRIPTION_SUCCESS"

// Error
export const SUBSCRIPTION_API_ERROR = "SUBSCRIPTION_API_ERROR"
